import Elm1 from '../Tipe 8/Tipe 8 (1).webp'
import Elm2 from '../Tipe 8/Tipe 8 (2).webp'
import Elm3 from '../Tipe 8/Tipe 8 (3).webp'
import Elm4 from '../Tipe 8/Tipe 8 (4).webp'
import Elm5 from '../Tipe 8/Tipe 8 (5).webp'
import Elm6 from '../Tipe 8/Tipe 8 (6).webp'
import Elm7 from '../Tipe 8/Tipe 8 (7).webp'
import Elm8 from '../Tipe 8/Tipe 8 (8).webp'
import Elm9 from '../Tipe 8/Tipe 8 (9).webp'
import Elm10 from '../Tipe 8/Tipe 8 (10).webp'
import Elm11 from '../Tipe 8/Tipe 8 (11).webp'

const Elmimages =[
Elm1,Elm2,Elm3,Elm4,Elm5,Elm6,Elm7,Elm8,Elm9,Elm10,Elm11
]

export default Elmimages;